import { ApiCommunicationManagerImpl } from './axios/api-communication-manager-impl';

const AppHttpClient = new ApiCommunicationManagerImpl(
  process.env.API_URL || 'undefined-url'
);

export default AppHttpClient;
